export default {
  methods: {
    async $getModelConfig(modelPath) {
      let config = [];

      try {
        const module = await import(`@/views/${modelPath}`);
        config = module.default;
      } catch (err) {
        console.warn(err.toString());
      }

      return config;
    },
  },
};
